import { callNative } from '@ifit/native-webview-interface';
import { useEffect } from 'react';

export interface IOptions {
  methodName?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

const useToolbarTitle = (
  title: string,
  { methodName = 'SetToolbarTitle', ...options }: IOptions = {},
  callback?: Function
): void => {
  useEffect(() => {
    document.title = title;
    callNative({
      methodName,
      title,
      ...options,
    });
    if (callback) callback();
  }, [title, methodName, ...Object.values(options)]); // eslint-disable-line react-hooks/exhaustive-deps
};

export default useToolbarTitle;
